/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Base from './base'

// @namespace Model
class Vote extends Base {
  url () {
    return '/vote.json'
  }
}

export default Vote
